export function CGConclusion({ deviation: contractedDeviation, analysis, isDark }: { deviation?: any; analysis?: any; isDark?: boolean }) {
  const deviation = contractedDeviation ?? analysis?.targetCG?.deviation
  const pct = (value: any) =>
    Number.isFinite(value) ? `${(value * 100).toFixed(1)}%` : '—'

  if (!deviation) return null

  const status = deviation.severity ?? deviation.status
  const isOk = status === 'ok'
  const isCritical = status === 'critical'
  const isWarning = status === 'warning'

  const statusConfig = isOk
    ? {
      label: 'Dans la tolérance',
      bg: isDark ? 'bg-emerald-500/15 border-emerald-500/30' : 'bg-emerald-50 border-emerald-200',
      badge: isDark ? 'bg-emerald-500/20 text-emerald-300 border-emerald-500/30' : 'bg-emerald-100 text-emerald-700 border-emerald-200',
      text: isDark ? 'text-emerald-300' : 'text-emerald-800',
      icon: '✓',
    }
    : isCritical
      ? {
        label: 'Écart important',
        bg: isDark ? 'bg-red-500/15 border-red-500/30' : 'bg-red-50 border-red-200',
        badge: isDark ? 'bg-red-500/20 text-red-300 border-red-500/30' : 'bg-red-100 text-red-700 border-red-200',
        text: isDark ? 'text-red-300' : 'text-red-800',
        icon: '✕',
      }
      : isWarning
        ? {
          label: 'Tolérance dépassée',
          bg: isDark ? 'bg-amber-500/15 border-amber-500/30' : 'bg-amber-50 border-amber-200',
          badge: isDark ? 'bg-amber-500/20 text-amber-300 border-amber-500/30' : 'bg-amber-100 text-amber-700 border-amber-200',
          text: isDark ? 'text-amber-300' : 'text-amber-800',
          icon: '⚠',
        }
        : {
          label: 'Non vérifié',
          bg: isDark ? 'bg-slate-500/10 border-slate-500/20' : 'bg-slate-50 border-slate-200',
          badge: isDark ? 'bg-slate-500/20 text-slate-400 border-slate-500/30' : 'bg-slate-100 text-slate-600 border-slate-200',
          text: isDark ? 'text-slate-400' : 'text-slate-600',
          icon: '?',
        }

  return (
    <div className={`rounded-lg border p-2.5 space-y-2 text-[10px] ${statusConfig.bg}`}>
      {/* Header statut */}
      <div className="flex items-center gap-2">
        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full font-bold border text-[9px] uppercase tracking-wide ${statusConfig.badge}`}>
          <span>{statusConfig.icon}</span>
          {statusConfig.label}
        </span>
      </div>

      {/* Métriques */}
      <div className={`grid grid-cols-2 gap-1.5 ${statusConfig.text}`}>
        <div className={`rounded-md px-2 py-1 ${isDark ? 'bg-black/20' : 'bg-white/60'}`}>
          <p className="opacity-60 font-semibold uppercase tracking-wide" style={{ fontSize: '8px' }}>Écart combiné</p>
          <p className="font-black text-xs mt-0.5">{pct(deviation.total_deviation_fraction ?? deviation.totalDeviation)}</p>
        </div>
        <div className={`rounded-md px-2 py-1 ${isDark ? 'bg-black/20' : 'bg-white/60'}`}>
          <p className="opacity-60 font-semibold uppercase tracking-wide" style={{ fontSize: '8px' }}>Tolérance</p>
          <p className="font-black text-xs mt-0.5">{pct(deviation.tolerance_fraction ?? deviation.tolerance)}</p>
        </div>
      </div>

      {/* Note */}
      <p className={`leading-snug ${isDark ? 'text-slate-500' : 'text-slate-500'}`}>
        Un écart <em>important</em> dépasse ×2 la tolérance X/Y. Cet indicateur n'évalue pas le basculement.
      </p>
    </div>
  )
}

export default function CGDiagnostics(_props: { analysis: any }) {
  return <div className="space-y-3 text-xs">
    {/* Lateral balance section moved to separate component and sub-tab */}
  </div>
}
